module.exports = __webpack_public_path__ + "img/userC05.543eb16c.jpg";